import { render, staticRenderFns } from "./rentcosttip.vue?vue&type=template&id=636b75c0&scoped=true"
import script from "./rentcosttip.vue?vue&type=script&lang=js"
export * from "./rentcosttip.vue?vue&type=script&lang=js"
import style0 from "./rentcosttip.vue?vue&type=style&index=0&id=636b75c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b75c0",
  null
  
)

export default component.exports